import { computed, unref } from 'vue';
import { storeToRefs } from 'pinia';
import { useThemeStore } from '@/stores/useThemeStore';

function toBoolean(v) {
	return `${v}`.toLowerCase() === 'true';
}

export function useInheritedSettings(elementRef) {
	const themeStore = useThemeStore();
	const { theme } = storeToRefs(themeStore);

	function getInheritedValue(path) {
		return path.split('.').reduce((obj, key) => obj?.[key], theme.value)?.settings;
	}

	return computed(() => {
		const el = unref(elementRef);
		if (!el) return null;

		if (toBoolean(el.inherited) && el.inherit) {
			return getInheritedValue(el.inherit);
		}

		return el.settings;
	});
}


export function useInheritedElements(elementsRef) {
	const get = (key) => useInheritedSettings(computed(() => elementsRef.value?.[key]));

	function getMany(keys) {
		return Object.fromEntries(keys.map((key) => [key, get(key)]));
	}

	return { get, getMany };
}
